import React from "react";
import NavbarClass from "../NavbarClass";
import Footer from "../footer/Footer";
import { Form } from "react-bootstrap";
import ParentsCard from "./ParentsCard";
import ActivityCard from "./ActivityCard";
import "./Parents.css";
import { fetchBlogs } from "../../actions/blogActions";
import { fetchActivities } from "../../actions/activityActions";
import { connect } from "react-redux";
import InfoModal from "../modals/InfoModal";
import history from "../../config/history";
import SkeletonCardsList from "../skeleton-card/SkeletonCardsList";
import { pageview } from "../../utils/googleAnalyticsUtils";
import { InView } from "react-intersection-observer";

class Parents extends React.Component {
  async componentDidMount() {
    pageview('Activities');
    await this.props.fetchBlogs(this.props.userStatus.isPremium);
    await this.props.fetchActivities();
  }

  state = {
    searchTerm: "",
    subscribeModalShow: false,
    activityImgsLoaded: 0,
    storyImgsLoaded: 0,
  };

  onActivityImgsLoad = () => {
    this.setState({
      activityImgsLoaded: this.state.activityImgsLoaded + 1,
    });
  };

  onStoryImgsLoad = () => {
    console.log(
      "story img load",
      this.state.storyImgsLoaded,
      this.props.blogsCount
    );
    this.setState({
      storyImgsLoaded: this.state.storyImgsLoaded + 1,
    });
  };

  handleShowSubscribeModal = () => {
    this.setState({
      subscribeModalShow: true,
    });
  };

  handleCloseSubscribeModal = () => {
    this.setState({
      subscribeModalShow: false,
    });
  };

  activityCardsWrapperRef = React.createRef();
  storyCardsWrapperRef = React.createRef();

  scrollCards = (scrollOffset, ref) => {
    ref.current.scrollBy({
      left: scrollOffset,
      behavior: "smooth",
    });
  };

  render() {
    return (
      <div
        style={{
          position: "relative",
          minHeight: "100vh",
          // paddingBottom: "5.6rem",
        }}
      >
        <InfoModal
          modalShow={this.state.subscribeModalShow}
          onHide={this.handleCloseSubscribeModal}
          closeButton={true}
          actionButton={() => history.push("/pricing")}
          heading={"Subscribe!"}
          bodyContent={"Subscribe to MenduToons to access premium content"}
          actionButtonText={"Subscribe"}
        />
        <div>
          <NavbarClass handleSignInOpen={this.props.handleSignInOpen} />

          <div>
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/activities_header_pc.webp`}
                width="1800"
                height="360"
                alt="It is a pastel coloured image showing Meendu's family. Meendu is standing in the center of the image. His parents are standing on the right side corner holding hands. His grandparents are standing on the left side corner holding hands. There is text written below them 'Yayy! It's family time! Because noone can teach your kids better than you.'"
              />
              <img
                src={`${process.env.REACT_APP_AWS_IMG_CDN}/banners/activities_header_mob.webp`}
                width="800"
                height="400"
                className="w-100"
                alt="It is a pastel coloured image showing Meendu's family. Meendu is standing in the center of the image. His parents are standing on the right side corner holding hands. His grandparents are standing on the left side corner holding hands. There is text written below them 'Yayy! It's family time! Because noone can teach your kids better than you.'"
              ></img>
            </picture>
          </div>
        </div>
        <div className="container content-container-parents-c">
          <InView threshold={0.1} triggerOnce>
            {({ inView, ref }) => (
              <div ref={ref} className={`hp-animate hp-animate--up ${inView ? "is-visible" : ""}`}>
                <div className="parents-content-heading">
                  <h2 className="hp-section-heading">
                    Fun Printables
                  </h2>
                  <Form.Control
                    className="parents-content-search-bar"
                    size="md"
                    type="text"
                    placeholder="Search printables…"
                    onChange={(e) => this.setState({ searchTerm: e.target.value })}
                  />
                </div>
                <div className="activity-cards-wrapper">
                  <div
                    className="parents-cards-left-scroll-btn parents-cards-scroll-btns"
                    onClick={() =>
                      this.scrollCards(-240, this.activityCardsWrapperRef)
                    }
                  >
                    <i className="fa fa-solid fa-arrow-left" />
                  </div>

                  <div
                    className="parents-cards-right-scroll-btn parents-cards-scroll-btns"
                    onClick={() =>
                      this.scrollCards(240, this.activityCardsWrapperRef)
                    }
                  >
                    <i className="fa fa-solid fa-arrow-right" />
                  </div>
                  <div
                    className="activity-cards-container-scroll"
                    ref={this.activityCardsWrapperRef}
                    style={
                      this.state.activityImgsLoaded >= this.props.activitiesCount
                        ? {}
                        : { display: "none" }
                    }
                  >
                    {this.props.activities &&
                      this.props.activities
                        .filter((val) => {
                          if (this.state.searchTerm == "") {
                            return val;
                          } else if (
                            val.title
                              .toLowerCase()
                              .includes(this.state.searchTerm.toLowerCase())
                          ) {
                            return val;
                          }
                        })
                        .map((activity, key) => (
                          <ActivityCard
                            activity={activity}
                            key={key}
                            handleShowSubscribeModal={this.handleShowSubscribeModal}
                            onActivityImgsLoad={this.onActivityImgsLoad}
                          />
                        ))}
                  </div>
                  <div
                    className="activity-cards-container-scroll"
                    style={
                      this.state.activityImgsLoaded >= this.props.activitiesCount
                        ? { display: "none" }
                        : {}
                    }
                  >
                    <SkeletonCardsList
                      count={
                        this.props.activitiesCount ? this.props.activitiesCount : 5
                      }
                      width="12rem"
                      height="16.9898rem"
                      borderRadius="5px"
                    />
                  </div>
                </div>
              </div>
            )}
          </InView>

          <InView threshold={0.1} triggerOnce>
            {({ inView, ref }) => (
              <div ref={ref} className={`hp-animate hp-animate--up delay-2 ${inView ? "is-visible" : ""}`}>
                <div className="parents-content-heading mt-5">
                  <h2 className="hp-section-heading">
                    Stories
                  </h2>
                </div>

                <div className="parents-cards-wrapper">
                  <div
                    className="parents-cards-left-scroll-btn parents-cards-scroll-btns"
                    onClick={() => this.scrollCards(-240, this.storyCardsWrapperRef)}
                  >
                    <i className="fa fa-solid fa-arrow-left" />
                  </div>
                  <div
                    className="parents-cards-right-scroll-btn parents-cards-scroll-btns"
                    onClick={() => this.scrollCards(240, this.storyCardsWrapperRef)}
                  >
                    <i className="fa fa-solid fa-arrow-right" />
                  </div>
                  <div
                    className="mb-2 parent-cards-container-scroll"
                    ref={this.storyCardsWrapperRef}
                    style={
                      this.state.storyImgsLoaded >= this.props.blogsCount
                        ? {}
                        : { display: "none" }
                    }
                  >
                    {this.props.blogs &&
                      this.props.blogs
                        .filter((val) => {
                          if (this.state.searchTerm == "") {
                            return val;
                          } else if (
                            val.title
                              .toLowerCase()
                              .includes(this.state.searchTerm.toLowerCase())
                          ) {
                            return val;
                          }
                        })
                        .map((blog, key) => (
                          <ParentsCard
                            handleShowSubscribeModal={this.handleShowSubscribeModal}
                            key={key}
                            blog={blog}
                            onStoryImgsLoad={this.onStoryImgsLoad}
                          />
                        ))}
                  </div>
                  <div
                    className="mb-2 parent-cards-container-scroll"
                    style={
                      this.state.storyImgsLoaded >= this.props.blogsCount
                        ? { display: "none" }
                        : {}
                    }
                  >
                    <SkeletonCardsList
                      count={this.props.blogsCount ? this.props.blogsCount : 5}
                      width="14rem"
                      height="9.5rem"
                      borderRadius="5%"
                    />
                  </div>
                </div>
              </div>
            )}
          </InView>
        </div>
        <br />
        <br />
        <Footer customStyles={{ position: "absolute", bottom: 0 }}></Footer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    blogs: state.blogs?.blogs?.blogs,
    activities: state.activities?.activities?.activities,
    blogsCount: state.blogs?.blogs?.blogsCount,
    activitiesCount: state.activities?.activities?.activitiesCount,
    userStatus: state.userLoggedinAndPremiumCheck,
  };
};

export default connect(mapStateToProps, {
  fetchBlogs,
  fetchActivities,
})(Parents);
